import React from 'react'
import OnVisible from 'react-on-visible'
import { Image } from 'newComponents'
import './styles.scss'

const Section = (props) => {
  const { className, children, bgImage, noWrapper } = props

  return (
    <OnVisible wrappingElement="section" className={`new-section ${className || ''}`}>
      {bgImage && <Image image={bgImage} className="section-bg" />}
      {noWrapper ? children : <div className="new-container">{children}</div>}
    </OnVisible>
  )
}

export default Section
